<div class="row mt-3" *ngIf="notLocationAllowed">
  <div class="center" *ngIf="showMessageLocation">
    <p-dialog [(visible)]="displaySpinner" [closable]="false" [modal]="true" [baseZIndex]="10000">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <app-modal-content></app-modal-content>
      </div>
    </p-dialog>
  </div>
  <div class="col-12 col-md-12" id="warningItem" *ngIf="!showMessageLocation">
    <div id="warning" class="alert alert-warning d-flex flex-column justify-content-center align-items-center">
      <i class="fas fa-exclamation-triangle fa-2x"></i>
      <h6 id="warningText">{{"onboarding.geolocation.message" | translate: {Default: "No fue posible obtener tu ubicación geográfica. Es obligatorio que habilites tu ubicación geográfica para poder realizar tu aplicación. Debes permitir los servicios de localización en la configuración de tu navegador."} }}</h6>
    </div>
  </div>
</div>